<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Partner Branch` : "Add Partner Branch" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.partner_id"
              :items="partners"
              item-text="name"
              item-value="id"
              label="Partner*"
              outlined
              dense
              hide-details="auto"
              @change="getSubPartners(), (form.sub_partner_id = null)"
              :rules="[rules.required]"
              :readonly="viewPartner"
              :append-icon="viewPartner ? '' : 'mdi-menu-down'"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model="form.sub_partner_id"
              :items="subPartners"
              item-text="name"
              item-value="id"
              label="Sub Partner"
              outlined
              dense
              hide-details="auto"
              :readonly="viewSubPartner || form.partner_id == null"
              :append-icon="viewSubPartner ? '' : 'mdi-menu-down'"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.name"
              label="Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.code"
              label="Code*"
              outlined
              dense
              maxlength="3"
              hide-details="auto"
              :readonly="edit"
              :rules="[rules.required, rules.code]"
              @input="form.code = form.code.toUpperCase()"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.email"
              label="Email"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.email]"
          /></v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.mobile_no"
              label="Mobile Number"
              outlined
              dense
              maxlength="10"
              hide-details="auto"
              :rules="[rules.mobile]"
          /></v-col>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.whatsapp_mobile_no"
              label="Whatsapp Number"
              outlined
              dense
              maxlength="10"
              hide-details="auto"
              :rules="[rules.mobile]"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    partnerBranch: {
      type: Object,
      default: () => {},
    },
    partners: {
      type: Array,
      default: () => [],
    },
    subPartners: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
    viewSubPartner: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.edit || this.viewPartner || this.viewSubPartner) {
        this.form = { ...this.partnerBranch };
        this.getSubPartners();
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.$emit("create", this.form);
      }
    },
    getSubPartners() {
      this.$emit("getSubPartners", this.form.partner_id);
    },
  },
};
</script>

<style scoped></style>
